<script setup>
import { useI18n } from 'vue-i18n'
import { useSidebarState } from '@/core/components/dss-sidebar/composables/use-sidebar-state'
import { SPACING, TRANSITION_DURATIONS } from '../constants/sidebar.constants'

const { collapsed } = useSidebarState()
const { t } = useI18n()
</script>

<template>
  <div
    class="flex items-center border-b border-b-dss-surface-200 shrink-0"
    :class="[SPACING.HEADER_GAP, SPACING.HEADER_PADDING]"
  >
    <sidebar-button-toggle />

    <transition
      :enter-active-class="`transition-opacity ${TRANSITION_DURATIONS.OPACITY} ease-in`"
      :leave-active-class="`transition-opacity ${TRANSITION_DURATIONS.OPACITY} ease-out`"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <span
        v-if="!collapsed"
        class="font-hellix font-light text-dss-surface-950 whitespace-nowrap"
      >
        {{ t('menu.title') }}
      </span>
    </transition>
  </div>
</template>
